import React from 'react'
import { LevelCircleCon, LevelProgressCon } from './styles'
import { AchievementSuccessMetric } from '../../Api'
import { abbreviateNumber } from '../../Utils'

type LevelProgressProps = {
  level: AchievementSuccessMetric
  userProg: number
  isComplete: boolean
  hideXP?: boolean
}

export const LevelItem: React.FC<LevelProgressProps> = ({
  level,
  userProg,
  isComplete = false,
  hideXP = false,
}) => {
  const completed = isComplete || userProg >= level.successMetric
  const levelXPValue = abbreviateNumber(level.successMetric)

  return (
    <LevelProgressCon>
      <LevelCircleCon completed={completed}>
        {!hideXP && <p className="levelText">{levelXPValue}</p>}
      </LevelCircleCon>
    </LevelProgressCon>
  )
}
